import React from 'react';

export default function StationStaple(props) {
    return (
        <div className="station-staple">
            <div className="station-staple__line station-staple__line--left" />
            <span className="station-staple__name">{props.station}</span>
            <div className="station-staple__line station-staple__line--right" />
        </div>
    );
}
